/**
 * COURE.HUB.DS.TransactionLog.Api
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type MessageSendingStatus = 1 | 2 | 3 | 4;

export const MessageSendingStatus = {
    NUMBER_1: 1 as MessageSendingStatus,
    NUMBER_2: 2 as MessageSendingStatus,
    NUMBER_3: 3 as MessageSendingStatus,
    NUMBER_4: 4 as MessageSendingStatus
};